import { configureStore } from "@reduxjs/toolkit";
import productReducer from "./features/product/productSlice";
import createSlice from "./features/orders/createSlice";
import orderSlice from "./features/Filters/orderSlice";
import transactionSlice from "./features/Filters/transactionSlice";

export default configureStore({
  reducer: {
    product: productReducer,
    order: createSlice,
    odderFilter: orderSlice,
    transactionFilter: transactionSlice,
  },
  devTools: false,
});
